// extracted by mini-css-extract-plugin
module.exports = {"box":"_1roapoA3QDOJWcDmkrELap"};